import { Controller } from "@hotwired/stimulus"
// import Choices from "choices.js"
//
export default class extends Controller {
//   connect() {
//     this.choices = new Choices(this.element, {
//       searchEnabled: false,
//       itemSelectText: '',
//       classNames: {
//         containerInner:['w-full','border','border-gray-300','rounded-md','shadow-sm','focus:ring-2','focus:ring-blue-500','focus:outline-none'],
//         input:['px-4','py-2','text-sm','text-gray-700'],
//         list:['bg-white','border','border-gray-200','rounded-md','mt-1'],
//         item:['px-2','py-1','text-sm','text-gray-800','bg-gray-100','rounded','mr-1'],
//         placeholder:['text-gray-400'],
//       }
//     });
//   }
}
